// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b1-4";
export var closeButton = "_b1-6";
export var dismissButton = "_b1-3";
export var editImageWithAiContainer = "_b1-8";
export var imageUploadWrapper = "_b1-7";
export var misspelledWord = "_b1-5";
export var spellCheckContainer = "_b1-2";
export var spin = "_b1-1";
export var spinning = "_b1-0";